import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable, Inject } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot } from '@angular/router';

import { ISnAuthConfig } from '../interfaces/auth-config.interface';
import { SN_AUTH_CONFIG } from '../providers/auth-config.provider';
import { SnSessionService } from '../services/session.service';

@Injectable()
export class SnUnauthorizedGuard implements CanActivate {
  constructor(
    private readonly _router: Router,
    private readonly _sessionService: SnSessionService,
    @Inject(SN_AUTH_CONFIG) private readonly _config: ISnAuthConfig,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this._sessionService.check().pipe(
      map((isAuthorized) => {
        return isAuthorized ? this._getRedirectAuthorizedTo() : true;
      }),
    );
  }

  private _getRedirectAuthorizedTo(): UrlTree {
    return this._router.parseUrl(this._config.redirectAuthorizedTo);
  }
}
